import React from 'react';
import { Button } from '@material-ui/core';
import './CheckoutBar.css';

export default function CheckoutBar(props) {
    const { onCheckout } = props;

    const handleClick = () => {
        onCheckout();
    }

    return (
        <div className="CheckoutBar-body padding-2x padding-2y text-right">
            <Button variant="contained" color="secondary" onClick={handleClick}>View Cart</Button>
        </div>
    );
}